module.exports = __webpack_public_path__ + "static/media/product4.ff67cbb0.png";